export const USERTYPE = {
  ENTREPRENEUR: "entrepreneur",
  INVESTOR: "investor",
  POLICY_MAKER: "policy_maker",
};
